var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 16.667L25 17.917l4.167 5.416H22.5v-2.5H20v2.5H5a3.322 3.322 0 00-3.333 3.334v5H5a5 5 0 1010 0h10a5 5 0 1010 0h3.333v-5A3.322 3.322 0 0035 23.333h-3.333l-5-6.666zM10 29.167a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm20 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: "#1F2CAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.389 16.623l1.222 2.105-1.222 2.105 2.222-1.157 2.222 1.157-1.222-2.105 1.222-2.105-2.222 1.158-2.222-1.158zM9.722 12.232l3-.842.89-2.842.888 2.842 3 .842-3 .842-.889 2.842-.889-2.842-3-.842zM10.313 14.123l-1.222 2.105 1.222 2.105-2.222-1.157-2.222 1.157 1.222-2.105-1.222-2.105L8.09 15.28l2.222-1.158z",
    fill: "#1F2CAF"
  })));
}
export default SvgBlueCarIcon;